/**
 * German relative-time formatting for the product-updates feed.
 * `now` is injectable so the branching logic is deterministically testable.
 */
export function relativeTime(iso: string | null, now: number = Date.now()): string {
  if (!iso) return '';
  const diffMs = now - new Date(iso).getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return 'gerade eben';
  if (mins < 60) return mins === 1 ? 'vor 1 Minute' : `vor ${mins} Minuten`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return hours === 1 ? 'vor 1 Stunde' : `vor ${hours} Stunden`;
  const days = Math.floor(hours / 24);
  if (days < 7) return days === 1 ? 'vor 1 Tag' : `vor ${days} Tagen`;
  const weeks = Math.floor(days / 7);
  if (weeks < 5) return weeks === 1 ? 'vor 1 Woche' : `vor ${weeks} Wochen`;
  return new Date(iso).toLocaleDateString('de-DE', { day: 'numeric', month: 'long', year: 'numeric' });
}
